<template>
<div class="ems-product-page ">
  <div class="bg-grey">
   <TitleBar :msg="msg"/>
   <div class="row-container doc1">
    <ul>
      <li><span class="management-icon" style="background-position:0 -12.7rem"></span><span>设备管理</span><p class="des">覆盖设备全生命周期，管理设备购置、安装、使用、维保、技术改造、直至报废等流程</p></li>
      <li><span class="management-icon" style="background-position:-2rem -8.7rem"></span><span>备品备件</span><p class="des">针对备品备件出库入库全流程以及盘点进行管理，将备品备件关联至所属设备上，实现快捷领用</p></li>
      <li><span class="management-icon" style="background-position:-2rem -12.7rem"></span><span>维修保养</span><p class="des">管理设备报修，报修送审，分派人员，维修，审批等，针对不同设备设置重要保养事项，有效预防故障发生</p></li>
      <li><span class="management-icon" style="background-position:-4rem -12.7rem"></span><span>工单管理</span><p class="des">支持维修、保养、巡检、自定义多类型工单管理，并对未及时处理工单进行工单调配操作，进一步提升效率</p></li>
      <li><span class="management-icon" style="background-position:-4rem -8.7rem"></span><span>巡检和盘点</span><p class="des">发起巡检计划，分配人员，支持设备拍照上传，有效监控设备状态。设备进行在线盘点，盘点过程轻松便捷</p></li>
      <li><span class="management-icon" style="background-position:-6rem -12.7rem"></span><span>设备知识库</span><p class="des">完善的设备档案功能，集中管理设备文档、说明、记录等档案。知识库记录维修信息，总结维修经验</p></li>
      <li><span class="management-icon" style="background-position:-4rem -10.7rem"></span><span>RFID标签和二维码</span><p class="des">采用一维码、二维码和RFID技术标识设备，实现“账、卡、物”相符，一键扫描快速识别，保障安全高效管理</p></li>
      <li><span class="management-icon" style="background-position:-8rem -8.7rem"></span><span>流程审批</span><p class="des">嵌入独立工作流引擎，针对设备和备品不同操作提供多项审批过程，可自定义审批规则满足各种操作审批需要</p></li>
      <li><span class="management-icon" style="background-position:-6rem -2rem"></span><span>手机移动端</span><p class="des">支持安卓、IOS、PDA等移动设备多端登录，协同管理，便捷报修、维修、巡检以及设备实时状态查询等操作</p></li>
    </ul>
   </div>
   <div class="buttonzu">
     <el-button class="border-button"  @click="openDocProduct" >了解更多</el-button>
     <el-button type="primary" @click="openConsultBox">免费试用</el-button>
   </div>
  </div>
  <div style="position:relative;" class="doc2">
    <div class="arrow"> <img :src="aimgaa" alt=""></div>
    <div class="text">
      <p class="title1" style="margin-bottom: 45px;">设备全生命周期动态信息管理</p>
      <ul>
        <li><div class="quanquan"><span  class="management-icon" style="background-position:0 -14.5rem"></span></div><p>采购</p></li>
        <li><div class="quanquan"><span  class="management-icon" style="background-position:-2rem -14.5rem"></span></div><p>台账</p></li>
        <li><div class="quanquan"><span  class="management-icon" style="background-position:-4rem -14.5rem"></span></div><p>维修</p></li>
        <li><div class="quanquan"><span  class="management-icon" style="background-position:-6rem -14.5rem"></span></div><p>保养</p></li>
        <li><div class="quanquan"><span  class="management-icon" style="background-position:-8rem -14.5rem"></span></div><p>运行</p></li>
        <li><div class="quanquan"><span  class="management-icon" style="background-position:0rem -16.6rem"></span></div><p>巡检</p></li>
        <li><div class="quanquan"><span  class="management-icon" style="background-position:-2rem -16.6rem"></span></div><p>报废</p></li>
      </ul>
    </div>
    <img :src="aimg" alt="" style="width:100%;">
  </div>
  <div class="doc3">
    <div class="imgright">
     <img :src="aimg1" alt="">
    </div>
    <div class="content">
      <p class="title1">设备唯一身份标识</p>
      <p class="title2">一维码/二维码/RFID标签...<br />一物一码，真正实现“帐、卡、物”相符</p>
      <el-button type="primary" @click="openConsultBox" style="margin-top:60px;">免费试用</el-button>
    </div>
  </div>
  <div style="background-color:#f5f7fa;">
    <div class="doc3 doc-right" >
      <div class="content">
        <p class="title1">设备日常维保 巡检报修管理</p>
        <ul>
          <li><i class="list-icon"></i>维保计划可自动触发维保提醒</li>
          <li><i class="list-icon"></i>日历化巡检扫码确认，规避假巡检</li>
          <li><i class="list-icon"></i>设备报修可记录维修工时及备件消耗</li>
        </ul>
        <el-button type="primary" @click="openConsultBox" style="margin-top:60px;">免费试用</el-button>
      </div>
      <div class="imgright">
      <img :src="aimg2" alt="">
      </div>
    </div>
  </div>
  <div class="doc3">
    <div class="imgright">
     <img :src="aimg3" alt="">
    </div>
    <div class="content">
      <p class="title1">日历视图工单管理</p>
      <p class="title2">从工单创建、流转、到解决时效全程监控，记录在案，支持多类型工单，工单内容可定义，支持在移动端进行工单全流程的处理，满足企业个性化工单需求</p>
      <el-button type="primary" @click="openConsultBox" style="margin-top:60px;">免费试用</el-button>
    </div>
  </div>
  <div style="position:relative;text-align:center;" class="doc2 blackbg">
    <div class="text">
      <p class="title1">设备运行状态可视化监控</p>
      <p class="title2">实时采集、分析设备运行数据，并通过直观的可视化图表和大屏看板呈现，帮助用户快速掌握设备运行状况，及时发现潜在问题，实现预测性维护，提高设备运行效率，降低运维成本</p>
    </div>
    <img :src="aimgb" alt="" style="margin-top:180px;width: 61%;">
  </div>
  <div class="doc4">
    <TitleBar :msg="msg2"/>
    <ul>
      <li><router-link to="/emssolution/1"><img :src='faimg[0]' alt=""><p>设备维修管理</p></router-link></li>
      <li><router-link to="/emssolution/2"><img :src='faimg[1]' alt=""><p>设备点巡检</p></router-link></li>
      <li><router-link to="/emssolution/3"><img :src='faimg[2]' alt=""><p>工单管理</p></router-link></li>
      <li><router-link to="/emssolution/4"><img :src='faimg[3]' alt=""><p>RFID设备管理</p></router-link></li>
      <li><router-link to="/emssolution/5"><img :src='faimg[4]' alt=""><p>移动APP设备管理系统</p></router-link></li>
      <li><router-link to="/emssolution/6"><img :src='faimg[5]' alt=""><p>设备数据中心</p></router-link></li>
    </ul>
  </div>
  <div style="background-color:#f5f7fa;">
    <div class="doc5">
       <TitleBar :msg="msg3"/>
      <ul>
        <li> <router-link to="/products/8"><span class="management-icon" style="background-position:0 -9.5rem;"></span><p class="title1">设备管理系统<span class="arrow-icon"></span></p><p class="des">实现设备从采购、入库、领用、维修到报废的全生命周期数字化管理</p></router-link></li>
        <li> <router-link to="/emshandwareProducts"><span class="management-icon" style="background-position:-10.5rem -6rem;"></span><p class="title1">相关硬件搭配<span class="arrow-icon"></span></p><p class="des">所需的相关硬件，包括条码打印机/扫描枪/高速扫描仪等</p></router-link></li>
      </ul>
    </div>
  </div>
 
</div>
</template>
<script>
import TitleBar from './TitleBar.vue'

import a from '../assets/emsbanner1.png'
import b from '../assets/emsbanner5.png'
import aa from '../assets/emsbanner1-arrow.png'
import a1 from '../assets/emsbanner2.png'
import a2 from '../assets/emsbanner3.png'
import a3 from '../assets/emsbanner4.png'
import fa1 from '../assets/emsFA1.png'
import fa2 from '../assets/emsFA2.png'
import fa3 from '../assets/emsFA3.png'
import fa4 from '../assets/emsFA4.png'
import fa5 from '../assets/emsFA5.png'
import fa6 from '../assets/emsFA6.png'
import { get, imageFile } from '../plugins/request.js'
import getQueryString from '../plugins/getQueryString.js'

export default {
  name: 'emsProductPage',
  components: {
    TitleBar
  },
  data() {
    return {
      msg: {
        title: '智慧设备管理一体化解决方案',
        subTitle: '强大的系统功能，优质的用户体验'
      },
      msg2: {
        title: '解决方案',
        subTitle: '根据流程和需求，量身定制个性化解决方案'
      },
      msg3: {
        title: '更多的相关软件产品',
        subTitle: '软件系统和硬件搭配方案，设备全生命周期的智能化管理'
      },
      aimg:a,
      aimg1:a1,
      aimg2:a2,
      aimg3:a3,
      aimgb:b,
      aimgaa:aa,
      faimg:[fa1,fa2,fa3,fa4,fa5,fa6],
      items: [
        { title: '', des: '' },
        { title: '', des: '' },
        { title: '', des: '' }
      ]
    }
  },
  methods: {
    openConsultBox(){
      window.$crisp.push(['do', 'chat:open']);
    },
    openDocProduct(){
      this.$router.push('/products/8')
    }
  },
  created: function(){
   
  },
  
}
</script>
<style lang="scss">
.ems-product-page {
  font-size: 0.8rem;
  line-height: 2;
  .bg-grey{
    background: #f5f7fa;
    padding-bottom: 2.5rem;
  }
  .buttonzu{
    text-align: center;
    margin-top: 1.5rem;
    .el-button.border-button{
      color: #444444;
    }
    .el-button.border-button:hover{
      border-color: #409EFF !important;
      background-color:transparent !important;
      color: #409EFF !important;
    }
  }
  
  .doc1{
    ul{
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      li{
        background:#fff;
        border-radius: 4px;
        display: inline-block;
        flex: 0 1 30%;
        font-size: 14px;
        padding: 1rem 2rem;
        box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
        margin-bottom: 2rem;
        word-break: break-all;
        span{
          font-size: 20px;
          font-weight: 600;
          
        }
        p{
          line-height: 20px;
        }
        .des{
          margin-top: 0.7rem;
        }
      }
    }
    .management-icon{
      vertical-align: -10px;
    }
  }
   .management-icon{
      display: inline-block;
      width: 2rem;
      height: 2rem;
      background: url(../assets/docIcons.png) no-repeat center;
      background-position:0 0;
      border: 0;
      background-size: 500%;
      margin-right: 10px;
    }
  .doc2{
    .arrow {
     position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
    .text{
      width: 1440px;
      position: absolute;
      top: 40%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      color: #fff;
      text-align: center;
      .management-icon{
        margin-right: 0;
        margin-top: 15px;
      }
       ul li{
        display: inline-block;
        font-size: 14px;
        .quanquan{
          border: 0.1px solid rgba(255, 255, 255, 0.1);
          width: 80px;
          height: 80px;
          border-radius: 50%;
          margin-bottom: 20px;
        }
        &+li{
          margin-left: 58px;
        }
      
      }
      .title1{
        font-size: 36px;
        font-weight: 600;
      }
      .title2{
        width: 22rem;
        margin-bottom: 2rem;
        line-height: 1.4;
      }
    }
    &.blackbg{
      background: #16204d;
      .text{
        text-align: center;
        top: 13%;
        .title2{
          width: 70%;
          margin: 0 auto;
        }
      }
    }
    
  }
  
  .doc3{
    display: flex;
    justify-content: space-between;
    max-width: 1340px;
    padding-left:0;
    padding-right:3rem;
    margin: 0 auto;
    align-items: center;
    &.doc-right{padding-left:3rem;padding-right:0;}
    .content{
      .title1{
        margin-bottom: 10px;
        font-size:32px;
        font-weight: 600;
      }
      .title2{
        font-size:20px;
        color:#353535;
        line-height: 1.4;
        width: 340px;
      }
    }
  }
  .doc4{
    max-width: 1400px;
    margin: 0 auto;
    text-align: center;
    ul{
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      li{
        display: inline-block;
        flex: 0 1 30%;
        font-size: 14px;
        border-radius: 6px;
        p{
          font-size: 18px;
          margin-bottom: 2rem;
        }
      }
      li:hover img{
        box-shadow: 0 8px 20px 0 rgba(55, 99, 170, .2);}
    }
  }
  .doc5{
    text-align: center;
    margin: 0 auto;
    max-width: 1400px;
    ul{
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      li{
        background:#fff;
        border-radius: 4px;
        display: inline-block;
        flex: 0 1 46%;
        margin-bottom: 2.5rem;
        a{
          display: block;
          text-align: left;
          font-size: 16px;
          padding: 2rem 2rem;
          .title1{
            font-size: 20px;
            font-weight: 600;
          }
        }
      }
      li:hover{
        box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
        .title1{
          color: #2a7acc;
        }
         .arrow-icon{
          background-position:-280px -137px;
        }
      }
    }
    .management-icon{
      display: inline-block;
      width: 3.2rem;
      height: 3.2rem;
      background: url(../assets/docIcons.png) no-repeat center;
      background-position:0 0;
      border: 0;
    }
    .arrow-icon{
      display: inline-block;
      width: 10px;
      height: 18px;
      background: url(../assets/docIcons.png) no-repeat center;
      background-position:-280px -120px;
      margin-left: 10px;
      vertical-align: -1px;
    }
  }
   .list-icon{
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url(../assets/docIcons.png) no-repeat center;
      background-position:-278px -156px;
      margin-right: 10px;
      vertical-align: -4px;
    }
}
</style>